{
  "branch": "KAR-2542",
  "commit_hash": "4b4b4c1",
  "node": "v20.19.4",
  "npm": "11.18.0",
  "nvm": null,
  "environment": "development",
  "compiled": "07.10.2026, 10:54:38"
}